import { SelectSearchField } from 'components'
import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useFormikContext } from 'formik'
import { DEAL_PAYMENT_METHOD_OPTIONS, PAYMENT_METHOD } from '../../constants'

const propTypes = {
  name           : PropTypes.string,
  label          : PropTypes.string,
  required       : PropTypes.bool,
  variant        : PropTypes.oneOf(['legacy', 'deal_v2']),
  onSelectOption : PropTypes.func,
}

const defaultProps = {
  name           : '',
  label          : '',
  required       : true,
  variant        : 'legacy',
  onSelectOption : () => {},
}

// NEW: legacy list tetap dipertahankan supaya pemakaian komponen di tempat lain tidak rusak
const LEGACY_PAYMENT_METHOD_OPTIONS = [
  {
    label: 'Cash',
    value: PAYMENT_METHOD.CASH,
    installment: null,
  },
  {
    label: 'EDC',
    value: PAYMENT_METHOD.EDC,
    installment: null,
  },
  {
    label: 'Virtual Account (Full Payment)',
    value: PAYMENT_METHOD.VIRTUAL_ACCOUNT,
    installment: null,
  },
  {
    label: 'Credit Cards (Full Payment)',
    value: PAYMENT_METHOD.CREDIT_CARD,
    installment: null,
  },
  {
    label: 'Direct Bank Transfer',
    value: PAYMENT_METHOD.MANUAL_TRANSFER,
    installment: null,
  },
]

const PAYMENT_METHOD_OPTIONS_BY_VARIANT = {
  legacy  : LEGACY_PAYMENT_METHOD_OPTIONS,
  deal_v2 : DEAL_PAYMENT_METHOD_OPTIONS,
}

/**
 * Search field to select payment method.
 * `variant="deal_v2"` => hide CC/VA, show MIDTRANS/EDC BRI/EDC BCA
 */
const PaymentMethodSelectSearchField = ({
  name,
  label,
  required,
  variant,
  onSelectOption,
  ...props
}) => {
  const { setFieldTouched, setFieldValue } = useFormikContext()

  const paymentMethodList = useMemo(
    () => PAYMENT_METHOD_OPTIONS_BY_VARIANT[variant] || PAYMENT_METHOD_OPTIONS_BY_VARIANT.legacy,
    [variant]
  )

  const [ filteredPaymentMethodList, setFilteredPaymentMethodList ] = useState(paymentMethodList)
  const isSearchLoading = false

  useEffect(() => {
    setFilteredPaymentMethodList(paymentMethodList)
  }, [paymentMethodList])

  const getOptionLabel = (option) => option?.label || ''

  const setFilteredPaymentMethodByQuery = (list, searchText = '') => {
    const normalizedSearchText = (searchText || '').toString().trim().toLowerCase()

    if (!normalizedSearchText) {
      setFilteredPaymentMethodList(list)
      return
    }

    const filtered = list.filter((option) => {
      const labelText = (option?.label || '').toLowerCase()
      const valueText = (option?.value || '').toLowerCase()

      return labelText.includes(normalizedSearchText) || valueText.includes(normalizedSearchText)
    })

    setFilteredPaymentMethodList(filtered)
  }

  const handleSelectSearchOnChange = (event) => {
    const searchText = event?.target?.value || ''
    setFilteredPaymentMethodByQuery(paymentMethodList, searchText)
  }

  return (
    <SelectSearchField
      type='text'
      name={ name }
      label={ label }
      placeholder='Search payment method...'
      dataList={ filteredPaymentMethodList }
      onSearchChange={ handleSelectSearchOnChange }
      getOptionLabel={ getOptionLabel }
      isLoading={ isSearchLoading }
      required={ required }
      onSelect={(selectedOption) => {
        // NEW: keep object shape in Formik for backward compatibility
        setFieldValue(name, selectedOption || null)
        setFieldTouched(name, true, false)
        onSelectOption(selectedOption || null)
      }}
      { ...props }
    />
  )
}

PaymentMethodSelectSearchField.propTypes = propTypes
PaymentMethodSelectSearchField.defaultProps = defaultProps

export default PaymentMethodSelectSearchField
